import crest from "@/assets/crest.png"
import { useAppConfig } from "@/stores/appConfigStore"
import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"

const nameStyles = css`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	height: 3rem;
	margin: 0 0.5rem;

	img {
		height: 1.75rem;
	}
	span {
		font-size: 1.125rem;
		font-weight: 600;
		color: #f0f0f0;
	}

	border-bottom: thin solid rgba(255, 255, 255, 0.35);

	@media (max-width: 80rem) {
		justify-content: center;
		& > span {
			display: none;
		}
		img {
			height: 2rem;
		}
	}
`

const AppName: ReactiveComponent = () => {
	const appConfig = useAppConfig()

	return () => (
		<div class={nameStyles}>
			<img src={crest} alt="logo" />
			<span>{appConfig.appName}</span>
		</div>
	)
}

export default defineComponent(AppName)
